import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';

import graphic from '../../assets/underDevelopment.png';

const styles = theme => ({
  dialogPaper: {
    overflow: 'inherit',
    width: '95vw',
    maxWidth: 800
  },
  dialogActions: {
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxHeight: 100,
    '&> div': {
      maxHeight: 100
    }
  },
  button: {
    background: '#3d3f72',
    color: '#fff',
    '&:disabled': {
      background: '#ddd',
      color: '#3d3f7255'
    },
    '&:hover': {
      background: '#3d3f72DD',
      color: '#fff'
    },
    marginTop: 10,
    marginBottom: 10
  }
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2
  }
}))(MuiDialogContent);

const LoginModal = ({
  classes,
  config,
  handleClose,
  login,
  open,
  pushToast
}) => {
  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ error, setError ] = useState('');

  useEffect(() => {
    setUsername('');
    setPassword('');
    setError('');
  }, [ open ]);

  const handleSubmit = async () => {
    try {
      await login({
        username,
        password,
        office: config.authenticateOffice
      });
    } catch (err) {
      console.log(err);
      const msg = typeof err === 'string'
        ? err
        : get(err, 'body.warning', 'There was an error');
      setError(msg);
    }
  };

  return (
    <div>
      <Dialog
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        classes={{ paper: classes.dialogPaper }}
        open={open}
        repositionOnUpdate={false}
        onClose={handleClose}
      >
        <form
          style={{ overflowY: 'scroll' }}
          onSubmit={async ev => {
            ev.preventDefault();
            try {
              handleSubmit();
            } catch (e) {
              pushToast({ error: e, entity: 'Logging in' });
            }
          }}
        >
          <DialogContent style={{ display: 'flex' }}>
            <LoginModal.LeftContent>
              <img
                alt='under construction'
                src={graphic}
                style={{ width: '100%' }}
              />
              <span>{config && config.betaMessage}</span>
            </LoginModal.LeftContent>
            <LoginModal.RightContent>
              <LoginModal.OfficeTitle>
                {config && config.authenticateOffice}
              </LoginModal.OfficeTitle>
              <LoginModal.Header>Tax Transparency Sign-in</LoginModal.Header>
              <TextField
                label='Username'
                style={{ marginBottom: 15 }}
                value={username}
                variant='outlined'
                onChange={v => setUsername(v.target.value)}
              />
              <TextField
                label='Password'
                type='password'
                value={password}
                variant='outlined'
                onChange={v => setPassword(v.target.value)}
              />
              <Button
                className={classes.button}
                // disabled={isDisabled}
                fullWidth
                type='submit'
                variant='contained'
              >
                SIGN IN
              </Button>
              <LoginModal.Error>{error}</LoginModal.Error>
              <LoginModal.PoweredBy>
                Website powered by{' '}
                <b style={{ fontWeight: '600' }}>&lt;True Prodigy&gt;</b>
              </LoginModal.PoweredBy>
            </LoginModal.RightContent>
          </DialogContent>
        </form>
      </Dialog>
    </div>
  );
};

LoginModal.LeftContent = styled.div`
  display: flex;
  flex: 3;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px;

  > span {
    text-align: center;
    font-family: HelveticaNeue, Arial, sans-serif;
    font-size: 20px;
  }
`;

LoginModal.RightContent = styled.div`
  display: flex;
  position: relative;
  flex: 2;
  flex-direction: column;
  box-shadow: -10px 4px 7px -10px rgba(0, 0, 0, 0.16);
  font-family: Roboto, Arial, sans-serif;
  min-width: 350px;
  min-height: 450px;
  padding: 20px;
`;

LoginModal.PoweredBy = styled.div`
  position: absolute;
  font-family: Arial, sans-serif;
  font-size: 12px;
  bottom: 0;
  right: 0;
  color: #383c9d;
`;

LoginModal.OfficeTitle = styled.div`
  display: flex;
  justify-content: center;
  font-size: 34px;
  font-weight: 900;
`;

LoginModal.Header = styled.div`
  font-size: 24px;
  line-height: 1.33;
  color: #383c9d;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
`;

LoginModal.Error = styled.div`
  color: red;
  font-family: Roboto, arial, sans-serif;
  font-size: 12px;
`;

LoginModal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pushToast: PropTypes.func.isRequired,
  unitId: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
  year: PropTypes.string.isRequired
};

export default withStyles(styles)(LoginModal);
